/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import { FontSizes, FontWeights, getTheme, IconButton } from "@fluentui/react";
import React from "react";
const theme = getTheme();
export const ShowNavigation2 = (): JSX.Element => {
    return <div style={{ fontWeight: FontWeights.regular, fontSize: FontSizes.smallPlus, color: theme.palette.neutralPrimary }}>
        <h3>  Navigate and save your emails.</h3>
        <p>When the pShareEmail starts appear three main areas-buttons. Each one represents</p>
        <ul>
            <li>Your OneDrive with its contents </li>
            <li>Teams that you can access</li>
            <li>SharePoint sites that you have access</li>
        </ul>

        <div style={{ textAlign: 'center' }}>
            <img width='200' src={require('../../../assets/1.png')} />
        </div>
        <p>        Selecting each of these areas you can find and navigate into your data. In this example OOneDrive is open and a list of folders appear. </p>
        <p>
            if you select this button <IconButton
                iconProps={{ iconName: 'share' }}
                title="See The Documents Into The Folder"
                ariaLabel="See The Documents Into The Folder"
                disabled={false}
                checked={false}
                styles={{ icon: { fontSize: FontSizes.small, color: theme.palette.themePrimary }, root: { height: 19, width: 19, backgroundColor: '#FFEB55', boxShadow: '0 0 0 0.5px ' + theme.semanticColors.buttonBorder } }}

            /> you will find all your files inside this folder
        </p>
        <p>If you select SharePoint you will notice that appear both lists and document libraries.
            <div style={{ textAlign: 'center' }}>
                <img width='200' src={require('../../../assets/4.png')} />
            </div>
        </p>
        <p>
            Every time that you select either list of document library the Breadcrumb changes.
        </p>
        <p> <b> Use the breadcrump to select your final destination and open  the metadata panel.</b></p>
    </div>;
};
